/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWebAuthnRegistrationCompleteResponse
 */
export interface OutputWebAuthnRegistrationCompleteResponse {
    /**
     * 
     * @type {number}
     * @memberof OutputWebAuthnRegistrationCompleteResponse
     */
    credentialId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWebAuthnRegistrationCompleteResponse
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputWebAuthnRegistrationCompleteResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the OutputWebAuthnRegistrationCompleteResponse interface.
 */
export function instanceOfOutputWebAuthnRegistrationCompleteResponse(value: object): boolean {
    return true;
}

export function OutputWebAuthnRegistrationCompleteResponseFromJSON(json: any): OutputWebAuthnRegistrationCompleteResponse {
    return OutputWebAuthnRegistrationCompleteResponseFromJSONTyped(json, false);
}

export function OutputWebAuthnRegistrationCompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWebAuthnRegistrationCompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'credentialId': json['credentialId'] == null ? undefined : json['credentialId'],
        'name': json['name'] == null ? undefined : json['name'],
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function OutputWebAuthnRegistrationCompleteResponseToJSON(value?: OutputWebAuthnRegistrationCompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credentialId': value['credentialId'],
        'name': value['name'],
        'success': value['success'],
    };
}

